var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "frequency-multiplication-select" },
    [
      _c("el-row", { staticClass: "frequency-multiplication-row" }, [
        _vm._v("\n    倍频选择：\n  ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "frequency-multiplication-row" },
        [
          _c(
            "el-checkbox",
            {
              on: { change: _vm.Fresh },
              model: {
                value: _vm.OneChecked,
                callback: function($$v) {
                  _vm.OneChecked = $$v
                },
                expression: "OneChecked"
              }
            },
            [_vm._v("倍频(1)")]
          ),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              placeholder: "              0.5×",
              disabled: true,
              size: "mini"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "frequency-multiplication-row" },
        [
          _c(
            "el-checkbox",
            {
              on: { change: _vm.Fresh },
              model: {
                value: _vm.DoubleChecked,
                callback: function($$v) {
                  _vm.DoubleChecked = $$v
                },
                expression: "DoubleChecked"
              }
            },
            [_vm._v("倍频(2)")]
          ),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              placeholder: "              1.0×",
              disabled: true,
              size: "mini"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "frequency-multiplication-row" },
        [
          _c(
            "el-checkbox",
            {
              on: { change: _vm.Fresh },
              model: {
                value: _vm.TripleChecked,
                callback: function($$v) {
                  _vm.TripleChecked = $$v
                },
                expression: "TripleChecked"
              }
            },
            [_vm._v("倍频(3)")]
          ),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              placeholder: "              2.0×",
              disabled: true,
              size: "mini"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea3bec66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea3bec66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RotatingMachineryThreeDimensionalHolography/FrequencyMultiplicationSelect.vue
// module id = null
// module chunks = 